export const CHECK_MARGIN_DATA = "CHECK_MARGIN_DATA";
export const REMOVE_MARGIN_DATA = "REMOVE_MARGIN_DATA";
export const CHECK_MARGIN_ERROR_DATA = "CHECK_MARGIN_ERROR_DATA";
export const CHECK_MARGIN_HIDE_ERROR_DATA = "CHECK_MARGIN_HIDE_ERROR_DATA";
export const CHECK_MARGIN_START_LOADER = "CHECK_MARGIN_START_LOADER";
export const CHECK_MARGIN_STOP_LOADER = "CHECK_MARGIN_STOP_LOADER";
